import { computed, Directive, input } from '@angular/core';
import { BrnLabel } from '@spartan-ng/brain/label';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmLabel]',
  hostDirectives: [
    {
      directive: BrnLabel,
      inputs: ['id'],
    },
  ],
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmLabel {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      'group-has-[.ng-invalid.ng-touched]:text-danger text-components-content-neutral-primary flex items-center gap-xs text-sm leading-none component-medium-semibold select-none group/label peer/label peer-ng-invalid:text-danger group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-components-content-neutral-quaternary peer-disabled:cursor-not-allowed peer-disabled:text-components-content-neutral-quaternary peer-data-[disabled]:cursor-not-allowed peer-data-[disabled]:text-components-content-neutral-quaternary has-[[disabled]]:cursor-not-allowed has-[[disabled]]:text-components-content-neutral-quaternary',
      this.userClass(),
    ),
  );
}
